import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import me from "../../Assets/me.jpg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function HomeFollow() {
	return (
		<Container fluid className="home-about-section" id="about">
			<Container>
				<Row>
					<Col md={8} className="home-about-description">
						<h1 style={{ fontSize: "2.6em" }}>
							LET ME <span className="purple"> INTRODUCE </span> MYSELF
						</h1>
						<p className="home-about-body">
						   I love programming and keep up with the latest technology and trends in the industry, constantly learning and improving my skills ☀️.
							<br />
							<br />
							My fields of Interest are building new &nbsp;
							<i>
								<b className="purple">Web Technologies and Products </b> and
								also in areas related to{" "}
								<b className="purple">
								 Distributed Systems, Microservices and Deep Learning.
								</b>
							</i>
							<br />
							<br />
							At work, I value team  
							 <b className="purple"> collaboration and communication, </b> and I enjoy
							<i>
								<b className="purple">
									{" "}
									thinking and solving problems 
								</b>
							</i>
							&nbsp; to pursue  
							<i>
								<b className="purple"> high-quality code </b>
							</i>
							and 
							<i>
								<b className="purple"> creating value at the work </b>
							</i>
							.
							<br />
							<br />
							
							Whenever, I am committed to  
							<b className="purple">
							{" "}
							  learning 
							</b>
							{" "}
							and eager to take on  
							<b className="purple">
							{" "}
							new challenges 
						    </b> 
							, so that I can continue to 
							<b className="purple">
							{" "}
							create value
							</b>
							{" "}
							 in my work while 
							 <b className="purple">
							{" "}
							growing personally
							</b>.
						</p>
					</Col>
					<Col md={4} className="myAvtar">
						<Tilt>
							<img src={me} loading="lazy" className="img-fluid" alt="avatar" />
						</Tilt>
					</Col>
				</Row>
				<Row>
					<Col md={12} className="home-about-social">
						<h1>FIND ME ON</h1>
						<p>
							Feel free to <span className="purple">connect </span>with me
						</p>
						<ul className="home-about-social-links">
							<li className="social-icons">
								<a
									href="https://github.com/ChengGuang-Li"
									target="_blank"
									rel="noreferrer"
									className="icon-colour  home-social-icons"
								>
									<AiFillGithub />
								</a>
							</li>
							<li className="social-icons">
								<a
									href="https://www.linkedin.com/in/chengguang-li-966198211/"
									target="_blank"
									rel="noreferrer"
									className="icon-colour  home-social-icons"
								>
									<FaLinkedinIn />
								</a>
							</li>
						</ul>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}
export default HomeFollow;
